/**
 * Balance Migration Type
 *
 * Defines how token balances should be migrated between accounts.
 * Used during user merge operations and account balance transfers.
 */
export var BalanceMigrationType;
(function (BalanceMigrationType) {
    /** Replace: New balance = from balance - to balance (diff only) */
    BalanceMigrationType["REPLACE"] = "replace";
    /** Merge: New balance = from balance (full transfer) */
    BalanceMigrationType["MERGE"] = "merge";
})(BalanceMigrationType || (BalanceMigrationType = {}));
//# sourceMappingURL=balance-migration-type.enum.js.map